/**
 * Grid column configuration for email flows
 * Single source of truth for column widths across FlowsTab, FlowRow, and FlowEmailTimeline
 */

export const FLOW_GRID_COLUMNS = {
    name: 30,
    sales: 15,
    sent: 10,
    openRate: 15,
    clickRate: 15,
    status: 15,
} as const;

/**
 * Header column definitions for FlowsTab
 */
export const FLOW_HEADER_COLUMNS = [
    {
        id: 'name',
        name: 'Name',
        width: FLOW_GRID_COLUMNS.name,
    },
    {
        id: 'sales',
        name: 'Sales',
        width: FLOW_GRID_COLUMNS.sales,
        className: 'hidden md:block',
    },
    {
        id: 'sent',
        name: 'Sent',
        width: FLOW_GRID_COLUMNS.sent,
        className: 'hidden md:block',
    },
    {
        id: 'open-rate',
        name: 'Open Rate',
        width: FLOW_GRID_COLUMNS.openRate,
        className: 'hidden md:block',
        helperText: 'CTOR is displayed as a percentage and total opens are displayed as numbers.',
    },
    {
        id: 'click-rate',
        name: 'Click Rate',
        width: FLOW_GRID_COLUMNS.clickRate,
        className: 'hidden md:block',
        helperText: 'CTR is displayed as a percentage and total clicks are displayed as numbers.',
    },
    {
        id: 'status',
        name: 'Status',
        width: FLOW_GRID_COLUMNS.status,
        className: 'hidden md:block',
    },
] as const;

/**
 * Generate grid template string from column percentages
 * @example getGridTemplate() // "40% 10% 10% 10% 10% 10%"
 */
export function getGridTemplate(): string {
    return Object.values(FLOW_GRID_COLUMNS)
        .map(width => `${width}%`)
        .join(' ');
}

/**
 * Generate grid template for timeline emails (uses minmax for responsive behavior)
 * @example getTimelineGridTemplate() // "minmax(0, 30%) minmax(0, 15%) minmax(0, 10%) minmax(0, 15%) minmax(0, 15%) minmax(0, 15%)"
 */
export function getTimelineGridTemplate(): string {
    return Object.values(FLOW_GRID_COLUMNS)
        .map(width => `minmax(0, ${width}%)`)
        .join(' ');
}
